export class FlightDateSave {


    dataLength: number
    end: string;
    margin: string
    priceText: string
    showLine: boolean
    start: string
    targetBudget: number
    widthContainer: string
    constructor(data) {

        this.dataLength = data.dataLength;
        this.end = data.end;
        this.margin = data.margin;
        this.priceText = data.priceText;
        this.showLine = data.showLine;
        this.start = data.start;
        this.targetBudget = data.targetBudget;
        this.widthContainer = data.widthContainer;
    }


}


// WEBPACK FOOTER //
// ./src/app/components/class/expense/flight-date-save.ts